import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg01.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Seamless Mobile Solutions: Revolutionary Mobile App Development
                NYC
              </h2>
            </div>
            <p>
              TekRevol is more than just a conventional mobile app development
              company in New York City; we are the trendsetters in the mobile
              app development arena. With our capable and experienced team of
              designers, app developers in NYC, and business development
              resources, we craft mobile applications for businesses of all
              magnitudes. In this way, we nurture exponential growth with
              innovative technology.
            </p>
            <p>
              As your dedicated tech partner, we classify and utilise profitable
              opportunities, unlocking your business's full potential. Our
              growth-oriented methods ensure maximum productivity and success in
              a seamless digital transformation. Choose TekRevol for innovative
              mobile app solutions.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
